import "./OpticksNumberCircle.css";

interface Props {
  number: string | number;
  completed?: boolean;
  /** Keep showing the number once completed instead of swapping it for a ✓. */
  keepNumber?: boolean;
}

const OpticksNumberCircle = ({ number, completed, keepNumber }: Props) => {
  return (
    <b
      className={`opticks-number-circle${completed ? " opticks-number-circle--completed" : ""}`}
    >
      {completed && !keepNumber ? "✓" : number}
    </b>
  );
};

export default OpticksNumberCircle;
